export function Logo({ size = "md", showText = true, light = false }) {
  const dim = size === "sm" ? "w-8 h-8 text-lg" : size === "lg" ? "w-12 h-12 text-3xl" : "w-10 h-10 text-2xl";
  const text = size === "sm" ? "text-lg" : size === "lg" ? "text-2xl" : "text-xl";
  return (
    <div className="flex items-center gap-1.5 font-display font-bold tracking-tight select-none" data-testid="app-logo">
      <div className={`relative flex items-center justify-center bg-slate-900 font-black ${dim} rounded-xl shadow-md border border-slate-800`}>
        <span className="text-sky-400">P</span>
      </div>
      <span className="px-1.5 py-0.5 rounded-md bg-sky-100 text-sky-700 font-mono text-[10px] font-bold uppercase tracking-widest border border-sky-200">
        hr
      </span>
      {showText && (
        <span className={`${text} font-extrabold ml-1 ${light ? "text-white" : "text-slate-900"}`}>
          PayFlex
        </span>
      )}
    </div>
  );
}
